module.exports = __webpack_public_path__ + "media/images/lp/lp14-b692753c1bb572c3d6dfc74284da10d1.webp";